import { createClient } from '@supabase/supabase-js';

const supabaseUrl = "https://aqlkbjqnvnkkfyklfvnx.supabase.co";
const supabaseKey = "sb_publishable_N9Dv5SjHSt4ehF1nDPrXRA_M2TdaBdh";

export const supabase = createClient(supabaseUrl, supabaseKey);
